import { Container } from '@chakra-ui/react';

export const CenterContainer = ({ children, ...props }) => (
  <Container maxW="calc(1224px + 1rem*2)" pt={4} pb={10} {...props}>
    {children}
  </Container>
);
